import styles from './EnfantsAmbassadeursHeader.module.css'

import {
  LogoMetropoleBasic,
  LogoVilleBasic,
  EnfantsAmbassadeurs,
} from '../../../svg/SvgComponents'

const EnfantsAmbassadeursHeader = () => (
  <>
    <header className={styles.header}>
      <div className={styles.logo}>
        <EnfantsAmbassadeurs width={304} height={60} />
      </div>
    </header>
  </>
)

export default EnfantsAmbassadeursHeader
